<template>
  <div class="register absolute">
    <div class="shading"></div>
    <div class="whiteBg">
      <div class="title acea-row row-center-wrapper">
        <div class="item on">账号登录</div>
      </div>
      <div class="list">
        <form>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input type="text" placeholder="输入手机号码" v-model="account" />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="password"
                placeholder="填写登录密码"
                v-model="password"
              />
            </div>
          </div>
        </form>
      </div>
      <div class="logon" @click="login">登录</div>
      <div class="tip"></div>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<script>
import { login } from "@api/user";
import { getQueryValue } from "@utils/utils";
export default {
  name: "Login",
  data: function() {
    return {
      account: "",
      password: ""
    };
  },
  mounted: function() {},
  methods: {
    login() {
      var that = this;
      if (!this.account) {
        this.$dialog.error("请输入账号");
      } else if (!this.password) {
        this.$dialog.error("请输入密码");
      } else {
        login({
          account: this.account,
          password: this.password
        })
          .then(res => {
            let data = res.data;
            let expires_time = data.expires_time.substring(0, 19);
            expires_time = expires_time.replace(/-/g, "/");
            expires_time = new Date(expires_time).getTime() - 28800000;
            const datas = {
              token: data.token,
              expires_time: expires_time
            };
            localStorage.setItem("LOGIN", JSON.stringify(datas));
            var shopids = getQueryValue("shopid");
            var baseUrl =
              window.location.protocol +
              "//" +
              window.location.host +
              "/scanCode?shopid=" +
              shopids;
            location.href = baseUrl;
            // that.$router.replace({
            //   path: "/scanCode",
            //   query: { shopid: shopids }
            // });
          })
          .catch(res => {
            that.$dialog.error(res.msg);
          });
      }
    }
  }
};
</script>
<style scoped></style>
